// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"76f7f5a7","977":"83e3e798"}[chunkId] + ".chunk.js";
};